import React, { useEffect, useState, useRef, useCallback } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getServiceSlice } from "../../../store/slices/serviceSlice";
import Select, { components } from "react-select";
import Diagnostics from "../services/diagnostics/Diagnostics";
import Physiotherapy from "../services/Physiotherapy/Physiotherapy";
import Dental from "../services/Dental/Dental";
import Radiology from "../services/Radiology/Radiology";
import Skin from "../services/Skin/Skin";
import Pharmacy from "../services/Pharmacy/Pharmacy";
import CathProfile from "../services/CATHProfile/CathProfile";
import InPateint from "../services/InPateint/InPateint";
import HospitalServiceCharges from "../services/HospitalServiceCharges/HospitalServiceCharges";
import HealthPackages from "../services/HealthPackages/HealthPackages";
import Consultation from "../services/consultation/Consultation";
import HealthScreening from "../services/HealthScreening/HealthScreening";
import Hair from "../services/Hair/Hair";
import General from "../services/General/General";
import OtherDignostics from "../services/OtherDiagnostics/OtherDignostics";
import Cardiology from "../services/cardiology/Cardiology";
import Pulmonary from "../services/Pulmonary/Pulmonary";
import CovidVaccination from "../services/CovidVaccination/CovidVaccination";
import BadCharges from "../services/BedCharges/BadCharges";
import CovidTest from "../services/Covidtest/CovidTest";
import AddUser from "./AddUser";
import AddReferrer from "./AddReferrer";
import {
  createAppointmentSlice,
  getAppointmentSlice,
  resetAppointmentCreateMessage,
} from "../../../store/slices/appointmentSlice";
import { getAllUsers } from "../../../store/slices/userSlice";
import {
  getAllPatient,
  createPatientData,
  resetMessage,
} from "../../../store/slices/patientSlice";
import InputDate from "../../common/Input/InputDate";
import styles from "./appointment.module.scss";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import { getAllClinic } from "../../../store/slices/clinicSlice";
import { IoIosAddCircle } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import AddUpdateModal from "../../components/Patient/AddUpdateModal";
import { getCountrySlice } from "../../../store/slices/countrySlice";
import { getStateSlice } from "../../../store/slices/state";
import { getDistricSlice } from "../../../store/slices/districtSlice";
import { getCitySlice } from "../../../store/slices/citySlice";
import {
  getAllReferrerList,
  updateReferrerList,
  createReferrerList,
} from "../../../store/slices/referrerList";
import AddUpdateReferrerList from "../ReferrerList/AddUpdateReferrerList";

const ApptModalCommon = ({
  setModalVisible,
  showModal,
  setShouldReset,
  shouldReset,
}) => {
  const { districts } = useSelector((state) => state.district);
  const { cities } = useSelector((state) => state.city);
  const { state } = useSelector((state) => state.state);
  const { Country } = useSelector((state) => state.country);
  const { services } = useSelector((state) => state.service);
  const { clinicInfo, allClinicLists } = useSelector((state) => state.clinic);
  const { users } = useSelector((state) => state.users);
  const { patients } = useSelector((state) => state.patient);
  const { userInfo, token } = useSelector((state) => state.auth);
  const { referrerList } = useSelector((state) => state.referrerList);
  const { appointmentCreateSuccessMessage, appointmentCreateErrorMessage } =
    useSelector((state) => state.appointmentSlice);
  const [selectedTimeOfTheDay, setSelectedTimeOfTheDay] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const initialState = {
    clinicId: null,
    clinicUserId: null,
    patientId: null,
    name: "",
    phone: "",
    password: "xyz",
    userType: 1,
    email: "",
    gender: "",
    age: {
      year: null,
      month: null,
      day: null,
    },
    dob: "",
    physicianId: null,
    physicianName: "",
    appDate: today,
    serviceMode: "",
    service: "",
    serviceName: "",
    serviceDetails: [
      {
        servicesId: "",
        id: "",
        type: "consultation",
      },
    ],
    selectedSlotId: "",
    timeOfTheDay: "",
    slotTime: "",
    specialization: null,
    specializationName: "",
    consultationType: "",
    referredByName: "",
    referredByPhone: "",
    referredByEmail: "",
    referredById: "",
    referalDetails: [
      {
        serviceId: "",
        serviceName: "",
        referalPercentage: "",
      },
    ],
    isClient: "No",
    clientId: "",
    clientName: "",
    numberOfSessions: null,
    endDate: "",
    status: "Active",
    serviceDetailsInfo: [],
  };
  const [formData, setFormData] = useState(initialState);
  const [showResult, setShowResult] = useState(true);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showReferrerModal, setShowReferrerModal] = useState(false);
  const [showPatientModal, setShowPatientModal] = useState(false);
  const [patientFormData, setPatientFormData] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [selectId, setSelectId] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  const initialStateForReferrer = {
    name: "",
    email: "",
    phone: "",
    status: "Active",
    referalDetails: [
      {
        serviceId: "",
        serviceName: "",
        referalPercentage: "",
      },
    ],
  };
  const [userFormData, setUserFormData] = useState(initialStateForReferrer);
  const [isMode, setIsMode] = useState(false);
  const [showModals, setshowModals] = useState(false);
  const [referrInput, setReferrInput] = useState({
    name: false,
    email: false,
    phone: false,
  });
  const [userInput, setUserInput] = useState({
    name: false,
    age: false,
    dob: false,
    gender: false,
    email: false,
  });
  const searchInputRef = useRef(null);
  const searchResultRef = useRef(null);
  const dispatch = useDispatch();
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const phoneExists = patients?.some(
    (p) => p?.userId?.phone === formData?.phone,
  );
  const clinicId = clinicInfo?.[0]?.clinicId;
  const [inputError, setInputError] = useState({
    name: false,
    email: false,
    phNumber: false,
    passport: false,
    aadhar: false,
  });

  const handleFileChange = (file) => {
    if (file) {
      setPatientFormData((prevData) => ({
        ...prevData,
        patient_image: file,
      }));
    }
  };

  useEffect(() => {
    dispatch(getCountrySlice({ status: ["Active"], token }));
    dispatch(
      getAllPatient({ patientAssociationId: clinicId, limit: 30, token }),
    );
  }, [dispatch, clinicInfo, token]);

  const handlePatientSelectChange = async (selectedOption, name) => {
    if (name === "country") {
      setPatientFormData((prevData) => ({
        ...prevData,
        country: selectedOption.value,
        countryName: selectedOption.label,
        state: "",
        stateName: "",
        district: "",
        districtName: "",
        city: "",
        cityName: "",
      }));
      await dispatch(getStateSlice({ countryId: selectedOption.value, token }));
    } else if (name === "state") {
      setPatientFormData((prevData) => ({
        ...prevData,
        state: selectedOption.value,
        stateName: selectedOption.label,
        district: "",
        districtName: "",
        city: "",
        cityName: "",
      }));
      await dispatch(getDistricSlice({ stateId: selectedOption.value, token }));
    } else if (name === "district") {
      setPatientFormData((prevData) => ({
        ...prevData,
        district: selectedOption.value,
        districtName: selectedOption.label,
        city: "",
        cityName: "",
      }));
      await dispatch(
        getCitySlice({
          countryId: patientFormData.country,
          stateId: patientFormData.state,
          districtId: selectedOption.value,
          token,
        }),
      );
    } else if (name === "city") {
      setPatientFormData((prevData) => ({
        ...prevData,
        city: selectedOption.value,
        cityName: selectedOption.label,
      }));
    } else {
      setPatientFormData((prev) => ({
        ...prev,
        [name]: selectedOption.value,
      }));
    }
  };

  const BloodGroupOptions = [
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },
  ];

  const MembershipOptions = [
    { value: "General", label: "General" },
    { value: "Gold", label: "Gold" },
    { value: "Silver", label: "Silver" },
  ];

  const Genderoptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "TransGender", label: "TransGender" },
  ];

  const handleAddPatient = async (e) => {
    e.preventDefault();
    const requiredFields = ["gender", "country", "state", "district", "city"];
    const errors = {};

    requiredFields.forEach((field) => {
      if (!patientFormData[field]) {
        errors[field] = `Please select ${field}`;
      }
    });

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }
    const { name, email, phNumber, aadhar, passport } = inputError;
    if (name || email || phNumber || aadhar || passport) {
      return;
    }
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("clinicId", clinicId);
      formDataToSend.append("clinicUserId", userInfo?._id);
      formDataToSend.append("name", patientFormData?.name || "");
      formDataToSend.append("email", patientFormData?.email || "");
      formDataToSend.append("phone", patientFormData?.phone || "");
      formDataToSend.append(
        "alternate_Phone",
        patientFormData?.alternate_Phone || "",
      );
      formDataToSend.append("userType", 1);
      formDataToSend.append("gender", patientFormData?.gender || "");
      formDataToSend.append("dob", patientFormData?.dob || "");
      formDataToSend.append("HC_number", patientFormData?.HC_number || "");
      formDataToSend.append(
        "aadhar_number",
        patientFormData?.aadhar_number || "",
      );
      formDataToSend.append("passport", patientFormData?.passport || "");
      formDataToSend.append("blood_group", patientFormData?.blood_group || "");
      formDataToSend.append("status", patientFormData?.status || "");
      formDataToSend.append(
        "membership_group",
        patientFormData?.membership_group || "",
      );
      formDataToSend.append("country", patientFormData?.country || "");
      formDataToSend.append("state", patientFormData?.state || "");
      formDataToSend.append("city", patientFormData?.city || "");
      formDataToSend.append("district", patientFormData?.district || "");
      formDataToSend.append("pin", patientFormData?.pin || "");
      formDataToSend.append("address", patientFormData?.address || "");
      formDataToSend.append("day", patientFormData?.age?.day || "");
      formDataToSend.append("month", patientFormData?.age?.month || "");
      formDataToSend.append("year", patientFormData?.age?.year || "");
      formDataToSend.append("abhaNumber", patientFormData?.abhaNumber || "");
      formDataToSend.append("abhaAddress", patientFormData?.abhaAddress || "");
      if (patientFormData.patient_image) {
        formDataToSend.append("patient_image", patientFormData?.patient_image);
      }
      const response = await dispatch(
        createPatientData({ formDataToSend, token }),
      );
      const newPatient = response?.payload?.result?.list;
      if (newPatient?.patientId) {
        dispatch(
          getAllPatient({
            patientAssociationId: clinicId,
            limit: 30,
            token,
          }),
        );
        setShowPatientModal(false);
        setModalVisible(true);
        setPatientFormData({});
        setFormData((prev) => ({
          ...prev,
          patientId: newPatient?.patientId,
          name: newPatient?.name,
          phone: newPatient?.phone,
        }));
        setTimeout(() => {
          dispatch(resetMessage());
        }, 200);
      }
    } catch (error) {
      console.error("Error details:", error);
    }
  };

  const resetForm = () => {
    setFormData(initialState);
    setReferrInput({ name: false, email: false });
  };

  const fetchInitialData = useCallback(() => {
    if (!token || !clinicId) return;
    dispatch(getServiceSlice({ status: ["Active"], token }));
    dispatch(
      getAppointmentSlice({
        clinicId,
        token,
        currentPage: 1,
        limit: 10,
      }),
    );
    dispatch(
      getAllClinic({
        loginRole: "Client",
        token,
        clinicId,
      }),
    );
    dispatch(getAllUsers({ token }));
    dispatch(getAllReferrerList({ token, status: ["Active"], clinicId }));
  }, [dispatch, token, clinicInfo]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  useEffect(() => {
    if (shouldReset) {
      resetForm();
      setShouldReset(false);
    }
  }, [shouldReset, setShouldReset]);

  useEffect(() => {
    if (showModal) {
      setReferrInput({ name: false, email: false });
      setUserInput({
        name: false,
        age: false,
        dob: false,
        gender: false,
        email: false,
      });
    }
  }, [showModal]);
  useEffect(() => {
    showTostifyMessageAndReset(
      appointmentCreateSuccessMessage,
      showToastifySuccess,
      resetAppointmentCreateMessage,
    );
    showTostifyMessageAndReset(
      appointmentCreateErrorMessage,
      showToastifyError,
      resetAppointmentCreateMessage,
    );
  }, [
    appointmentCreateSuccessMessage,
    appointmentCreateErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);

  const calculateAgeFromDob = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();
    if (days < 0) {
      months -= 1;
      days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }
    return { year: years, month: months, day: days };
  };

  const calculateDobFromAge = (age) => {
    const today = new Date();
    if (isNaN(today.getTime())) return "";
    today.setFullYear(today.getFullYear() - age.year || 0);
    today.setMonth(today.getMonth() - age.month || 0);
    today.setDate(today.getDate() - age.day || 0);
    return today.toISOString().split("T")[0];
  };
  useEffect(() => {
    if (showModal) {
      setFormData((prev) => ({
        ...prev,
        appDate: new Date().toISOString().split("T")[0],
      }));
    }
  }, [showModal]);
  const handleChange = (e, names) => {
    switch (names) {
      case "searchUser":
        const value = e.target.value;
        if (value?.length > 10) return;
        setFormData((prev) => ({
          ...prev,
          phone: value,
          name: "",
        }));
        dispatch(
          getAllPatient({
            patientAssociationId: clinicId,
            searchQuery: value,
            limit: 30,
            token,
          }),
        );
        break;
      case "searchReferr":
        const refValue = e.target.value;
        if (refValue?.length > 10) return;
        dispatch(getAllUsers({ searchKey: refValue, token }));
        setFormData((prev) => ({ ...prev, referredByPhone: e.target.value }));
        break;
      case "appDate":
        const selectedDate = new Date(e.target.value);
        const dayNames = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        const selectedDay = dayNames[selectedDate.getDay()];
        setFormData((prev) => ({
          ...prev,
          appDate: e.target.value,
          day: selectedDay,
          timeOfTheDay: "",
          slotTime: "",
        }));
        setSelectedTimeOfTheDay(null);
        break;
      case "age":
        const updatedAge = {
          ...formData.age,
          [e.target.name]: Number(e.target.value) || 0,
        };
        setFormData((prev) => ({
          ...prev,
          age: updatedAge,
          dob: calculateDobFromAge(updatedAge),
        }));
        break;
      case "dob":
        const dob = e.target.value;
        const calculatedAge = calculateAgeFromDob(dob);
        setFormData((prev) => ({
          ...prev,
          dob,
          age: calculatedAge,
        }));
        break;
      case "services":
        const serviceName = e.label;
        setFormData((prev) => ({
          ...prev,
          service: e.value,
          serviceName,
          isClient: serviceName === "Consultation" ? "No" : prev.isClient,
          clientId: serviceName === "Consultation" ? "" : prev.clientId,
          clientName: serviceName === "Consultation" ? "" : prev.clientName,
        }));
        break;
      case "physician":
        setFormData((prev) => ({
          ...prev,
          physicianId: e.value,
          physicianName: e.label,
        }));
        break;
      case "gender":
        setFormData((prev) => ({ ...prev, gender: e.value }));
        break;
      case "isClient":
        const isClientVal = e.target.value;
        setFormData((prev) => ({
          ...prev,
          isClient: isClientVal,
          clientId: isClientVal === "No" ? "" : prev.clientId,
          clientName: isClientVal === "No" ? "" : prev.clientName,
        }));
        break;
      case "serviceDetails":
        const serviceDetailsValues = e?.map((service) => ({
          id: service?.id,
          name: service?.name,
          price: service?.price ?? 0,
          type: service?.type || "consultation",
        }));
        setFormData((prev) => ({
          ...prev,
          serviceDetails: serviceDetailsValues,
        }));
        break;
      case "client":
        setFormData({ ...formData, clientId: e.value, clientName: e.label });
        break;
      case "numberOfSessions":
        const sessionCount = parseInt(e.target.value, 10);
        if (!isNaN(sessionCount) && formData.appDate) {
          const appDate = new Date(formData.appDate);
          if (!isNaN(appDate.getTime())) {
            const newEndDate = new Date(appDate);
            newEndDate.setDate(appDate.getDate() + sessionCount);
            setFormData((prev) => ({
              ...prev,
              numberOfSessions: e.target.value,
              endDate: newEndDate.toISOString().split("T")[0],
            }));
          } else {
            setFormData((prev) => ({
              ...prev,
              numberOfSessions: e.target.value,
              endDate: "",
            }));
          }
        } else {
          setFormData((prev) => ({
            ...prev,
            numberOfSessions: e.target.value,
            endDate: "",
          }));
        }
        break;
      default:
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const dayOptions = [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
  ];

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];

  const handleClickOutside = (event) => {
    if (
      searchInputRef.current &&
      !searchInputRef.current.contains(event.target) &&
      searchResultRef.current &&
      !searchResultRef.current.contains(event.target)
    ) {
      setShowResult(false);
    }
  };

  const handleserviceModeChange = (selectedMode) => {
    setFormData({ ...formData, serviceMode: selectedMode.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.isClient === "Yes" && !formData.clientId) {
      showToastifyError("Please select a client.");
      return;
    }
    try {
      setSubmitLoading(true);
      const createRes = await dispatch(
        createAppointmentSlice({
          ...formData,
          patientId: formData?.patientId,
          clinicId,
          clinicUserId: clinicInfo[0]?.userId?._id,
          createdBy: clinicInfo[0]?.userId?._id,
          token,
        }),
      );
      if (createRes?.payload?.success === true) {
        setModalVisible(false);
        setFormData(initialState);
      }
      await dispatch(
        getAppointmentSlice({
          clinicId,
          status: ["Active"],
          token,
          currentPage: 1,
          limit: 10,
        }),
      );
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      setSubmitLoading(false);
    }
  };

  const renderExtraFieldsComponent = () => {
    if (!formData.serviceName) return null;
    switch (formData.serviceName) {
      case "Pathology":
        return (
          <Diagnostics
            handleChange={handleChange}
            isClient={formData.isClient}
            formData={formData}
            setFormData={setFormData}
          />
        );
      case "Physiotherapy":
        return (
          <Physiotherapy
            isClient={formData.isClient}
            handleChange={handleChange}
            numberOfSessions={formData.numberOfSessions}
            appDate={formData.appDate}
          />
        );
      case "Dental":
        return (
          <Dental handleChange={handleChange} isClient={formData.isClient} />
        );
      case "Radiology":
        return (
          <Radiology handleChange={handleChange} isClient={formData.isClient} />
        );
      case "Skin":
        return (
          <Skin handleChange={handleChange} isClient={formData.isClient} />
        );
      case "Pharmacy":
        return <Pharmacy handleChange={handleChange} />;
      case "CATH Profile":
        return <CathProfile handleChange={handleChange} />;
      case "InPateint":
        return <InPateint handleChange={handleChange} />;
      case "Hospital Service Charges":
        return <HospitalServiceCharges handleChange={handleChange} />;
      case "Health-Package":
        return (
          <HealthPackages
            handleChange={handleChange}
            isClient={formData.isClient}
          />
        );
      case "Consultation":
        return (
          <Consultation
            dayOptions={dayOptions}
            formData={formData}
            setFormData={setFormData}
            clinicInfo={clinicInfo}
            selectedTimeOfTheDay={selectedTimeOfTheDay}
            setSelectedTimeOfTheDay={setSelectedTimeOfTheDay}
          />
        );
      case "Health-Screening":
        return (
          <HealthScreening
            handleChange={handleChange}
            isClient={formData.isClient}
          />
        );
      case "Hair":
        return (
          <Hair handleChange={handleChange} isClient={formData.isClient} />
        );
      case "General":
        return (
          <General handleChange={handleChange} isClient={formData.isClient} />
        );
      case "OtherDignostics":
        return <OtherDignostics handleChange={handleChange} />;
      case "Cardiology":
        return <Cardiology handleChange={handleChange} />;
      case "Pulmonary":
        return <Pulmonary handleChange={handleChange} />;
      case "CovidVaccination":
        return <CovidVaccination handleChange={handleChange} />;
      case "BadCharges":
        return <BadCharges handleChange={handleChange} />;
      case "CovidTest":
        return <CovidTest handleChange={handleChange} />;
      default:
        return null;
    }
  };

  const handleSetPhoneNumber = (e, names) => {
    const formattedDob = e.dob
      ? new Date(e.dob).toISOString().split("T")[0]
      : null;
    if (names === "phone") {
      setFormData({
        ...formData,
        phone: e?.phone,
        patientId: e?._id,
        name: e?.name,
        age: e.age,
        dob: formattedDob,
        gender: e.gender,
        email: e.email,
      });
      if (e.name) {
        setUserInput((prev) => ({
          ...prev,
          name: true,
        }));
      }
      if (e.age) {
        setUserInput((prev) => ({
          ...prev,
          age: true,
        }));
      }
      if (e.email) {
        setUserInput((prev) => ({
          ...prev,
          email: true,
        }));
      }
      if (e.gender) {
        setUserInput((prev) => ({
          ...prev,
          gender: true,
        }));
      }
    } else if (names === "referredByPhone") {
      setFormData({
        ...formData,
        referredById: e._id,
        referredByName: e.name,
        referredByPhone: e.phone,
        referredByEmail: e.email,
      });
      if (e.name) {
        setReferrInput((prev) => ({
          ...prev,
          name: true,
        }));
      }
      if (e.email) {
        setReferrInput((prev) => ({
          ...prev,
          email: true,
        }));
      }
    }
  };

  const serviceModes = [
    { value: "Home", label: "Home" },
    { value: "Clinic", label: "Clinic" },
  ];

  const handleOpenUserModal = () => {
    setModalVisible(false);
    setShowUserModal(true);
  };

  const handleOpenReferrerModal = () => {
    setModalVisible(false);
    setShowReferrerModal(true);
  };

  const handleSelectServiceDetailsChange = (selectedOption, index) => {
    setFormData((prev) => {
      const updatedReferalDetails = [...prev.referalDetails];
      updatedReferalDetails[index] = {
        ...updatedReferalDetails[index],
        serviceId: selectedOption?.value,
        serviceName: selectedOption?.label,
      };
      return { ...prev, referalDetails: updatedReferalDetails };
    });
  };

  const handleAddField = () => {
    setUserFormData((prev) => ({
      ...prev,
      referalDetails: [
        ...prev.referalDetails,
        { serviceId: "", serviceName: "", referalPercentage: "" },
      ],
    }));
  };

  const handleRemoveField = (index) => {
    if (index === 0) return;
    setFormData((prev) => {
      const updatedReferalDetails = [...prev.referalDetails];
      updatedReferalDetails.splice(index, 1);
      return { ...prev, referalDetails: updatedReferalDetails };
    });
  };

  const patientHandleChange = (e) => {
    if (e.dob && e.age) {
      setPatientFormData((prev) => ({
        ...prev,
        dob: e.dob,
        age: e.age,
      }));
    } else {
      const { name, value } = e.target;
      setPatientFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSelectChange = (selectedOption, index) => {
    setUserFormData((prev) => {
      const updatedReferalDetails = [...prev.referalDetails];
      updatedReferalDetails[index] = {
        ...updatedReferalDetails[index],
        serviceId: selectedOption?.value,
        serviceName: selectedOption?.label,
      };
      return { ...prev, referalDetails: updatedReferalDetails };
    });
  };

  const handleCloseModal = () => {
    setshowModals(false);
    setUserFormData(initialStateForReferrer);
    setIsMode(false);
    // setSelectId(null);
  };
  const handleChanges = (e, names) => {
    switch (names) {
      case "searchUser":
        dispatch(getAllUsers({ searchKey: e.target.value, token }));
        setUserFormData((prev) => ({ ...prev, phone: e.target.value }));
        break;
      default:
        setUserFormData((prev) => ({
          ...prev,
          [e.target.name]: e.target.value,
        }));
    }
  };
  const handleSetPhoneNumbers = (e, names) => {
    if (names === "phone") {
      setUserFormData({
        ...userFormData,
        phone: e.phone,
        patientId: e._id,
        name: e.name,
        email: e.email,
      });
      if (e.name) {
        setUserInput((prev) => ({
          ...prev,
          name: true,
        }));
      }
      if (e.email) {
        setUserInput((prev) => ({
          ...prev,
          email: true,
        }));
      }
    }
  };

  const handleAddUpdate = async (e) => {
    e.preventDefault();
    const { name, email, phNumber } = inputError;
    if (
      name ||
      email ||
      phNumber ||
      userFormData.referalDetails.some(
        ({ serviceId, referalPercentage }) => !serviceId || !referalPercentage,
      )
    ) {
      return showToastifyError("Please fill all required fields.");
    }
    const referrerData = {
      clinicId: clinicId,
      referalDetails: userFormData?.referalDetails,
    };
    const actionPayload =
      isMode && selectId
        ? {
            referrerId: selectId,
            ...referrerData,
            token,
            updatedData: {
              name: userFormData?.name,
              email: userFormData?.email,
              phone: userFormData?.phone,
              status: userFormData?.status,
            },
            updatedBy: userInfo?._id,
          }
        : {
            ...referrerData,
            name: userFormData?.name,
            email: userFormData?.email,
            phone: userFormData?.phone,
            status: userFormData?.status,
            token,
          };
    try {
      let response;
      if (isMode && selectId) {
        response = await dispatch(updateReferrerList(actionPayload));
      } else {
        response = await dispatch(createReferrerList(actionPayload));
      }
      setshowModals(false);
      await dispatch(
        getAllReferrerList({
          clinicId,
          status: ["Active"],
          token,
        }),
      );
      const refData = response?.payload?.result?.list;
      setUserFormData(initialStateForReferrer);
      setFormData((prev) => ({
        ...prev,
        referredById: refData?.user?._id,
        referredByName: refData?.user?.name,
        referredByPhone: refData?.user?.phone,
      }));
      setModalVisible(true);
    } catch (error) {
      console.error("Error in Add/Update operation:", error);
    }
  };
  return (
    <>
      <div onSubmit={handleSubmit}>
        <Modal
          centered
          show={showModal}
          onHide={() => {
            resetForm();
            setModalVisible(false);
          }}
          size="lg"
        >
          <div className="modal-header">
            <h4 className="modal-title">Add Appointment</h4>
            <button
              type="button"
              className="btn-close"
              onClick={() => setModalVisible(false)}
            ></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="row">
                <div className="col-xl-6">
                  <div className="form-group position-relative">
                    <label htmlFor="name" className="col-form-label">
                      Patient Name:
                    </label>
                    <Select
                      id="name"
                      name="name"
                      className="basic-single"
                      classNamePrefix="select"
                      value={
                        formData.patientId
                          ? {
                              label: formData.name,
                              value: formData.patientId,
                            }
                          : null
                      }
                      options={[
                        ...patients.map((patient) => ({
                          label: patient?.userId?.name,
                          value: patient?._id,
                          phone:
                            patient?.userId?.phone ||
                            patient?.userId?.alternate_Phone ||
                            "",
                        })),
                        {
                          label: "Add New Patient",
                          value: "add_new",
                          isAddNew: true,
                        },
                      ]}
                      // Search by both Name and Phone
                      filterOption={(option, inputValue) => {
                        const search = String(inputValue).toLowerCase();
                        const name = String(
                          option.data.label || "",
                        ).toLowerCase();
                        const phone = String(option.data.phone ?? "");
 
                        return name.includes(search) || phone.includes(search);
                      }}
                      components={{
                        Option: (props) => {
                          const { data, innerRef, innerProps } = props;
 
                          if (data.isAddNew) {
                            return (
                              <div
                                ref={innerRef}
                                {...innerProps}
                                className="d-flex align-items-center px-2 py-1 text-primary"
                                style={{ cursor: "pointer" }}
                              >
                                <FaPlus className="me-2" />
                                <span>{data.label}</span>
                              </div>
                            );
                          }
 
                          return (
                            <div
                              ref={innerRef}
                              {...innerProps}
                              className="px-3 py-2"
                              style={{
                                borderBottom: "1px solid #eee",
                                cursor: "pointer",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {data.label}
                              </div>
                              <div
                                style={{ fontSize: "0.85rem", color: "#888" }}
                              >
                                {data.phone}
                              </div>
                            </div>
                          );
                        },
                      }}
                      onInputChange={(inputValue) => {
                        if (!clinicId) return;
 
                        dispatch(
                          getAllPatient({
                            patientAssociationId: clinicId,
                            searchQuery: inputValue,
                           currentPage: 1,
                            limit: 30,
                            token,
                          }),
                        );
                      }}
                      placeholder="Select Patient"
                      onChange={(selectedOption) => {
                        if (selectedOption?.value === "add_new") {
                          setModalVisible(false);
                          setShowPatientModal(true);
                          setPatientFormData({});
                        } else {
                          const selectedPatient = patients.find(
                            (p) => p._id === selectedOption.value,
                          );
 
                          setFormData((prev) => ({
                            ...prev,
                            patientId: selectedOption.value,
                            name: selectedOption.label,
                            phone:
                              selectedPatient?.userId?.phone ||
                              selectedPatient?.userId?.alternate_Phone ||
                              "",
                          }));
                        }
                      }}
                      isSearchable
                      isDisabled={!!userInput?.name}
                    />
                  </div>
                </div>

                <div className="col-xl-6">
                  <div className="form-group position-relative">
                    <label htmlFor="phone" className="col-form-label">
                      Phone Number:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="phone"
                      name="phone"
                      value={formData.phone || ""}
                      placeholder="Phone Number"
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="form-group position-relative">
                    <label className="col-form-label">Referer Name:</label>
                    <Select
                      placeholder="Select Referer"
                      name="referredByName"
                      value={
                        formData.referredById
                          ? {
                              value: formData.referredById,
                              label: formData.referredByName,
                            }
                          : null
                      }
                      options={[
                        ...referrerList.map((ref) => ({
                          value: ref.userId?._id,
                          label: ref.userId?.name,
                          phone: ref.userId?.phone || "NA",
                        })),
                        {
                          label: "Add New Referer",
                          value: "add_new_ref",
                          isAddNew: true,
                        },
                      ]}
                      components={{
                        Option: (props) => {
                          const { data, innerRef, innerProps } = props;

                          if (data.isAddNew) {
                            return (
                              <div
                                ref={innerRef}
                                {...innerProps}
                                className="d-flex align-items-center px-2 py-1 text-primary"
                                style={{ cursor: "pointer" }}
                              >
                                <FaPlus className="me-2" />
                                <span>{data.label}</span>
                              </div>
                            );
                          }

                          return (
                            <div
                              ref={innerRef}
                              {...innerProps}
                              className="px-3 py-2"
                              style={{
                                borderBottom: "1px solid #eee",
                                cursor: "pointer",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {data.label}
                              </div>
                              <div
                                style={{ fontSize: "0.85rem", color: "#888" }}
                              >
                                {`+91 ` + data.phone}
                              </div>
                            </div>
                          );
                        },
                      }}
                      onChange={(selectedOption) => {
                        if (selectedOption?.value === "add_new_ref") {
                          setshowModals(true);
                          setModalVisible(false);
                          setUserFormData(initialStateForReferrer);
                          setFormData((prev) => ({
                            ...prev,
                            referredById: "",
                            referredByName: "",
                          }));
                        } else {
                          setFormData((prev) => ({
                            ...prev,
                            referredById: selectedOption.value,
                            referredByName: selectedOption.label,
                            referredByPhone: selectedOption.phone,
                          }));
                        }
                      }}
                      isSearchable
                      isDisabled={!!userInput?.referredByName}
                    />
                  </div>
                </div>

                {/* <div className="col-xl-6">
                  <div className="form-group position-relative">
                    <label htmlFor="referredByPhone" className="col-form-label">
                      Referer Number:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="referredByPhone"
                      name="referredByPhone"
                      value={formData.referredByPhone || ""}
                      placeholder="Referer Number"
                      readOnly
                    />
                  </div>
                </div> */}

                <div className="col-xl-6">
                  <InputDate
                    name="appDate"
                    value={formData.appDate}
                    onChange={(e) => handleChange(e, "appDate")}
                    placeholder="Date"
                    min={new Date().toISOString().split("T")[0]}
                  />
                </div>
                <div className="col-xl-6">
                  <div className="form-group position-relative">
                    <label htmlFor="application" className="col-form-label">
                      Services:
                    </label>
                    <Select
                      options={
                        services &&
                        services?.map((service, i) => ({
                          value: service?._id,
                          label: service?.serviceName,
                        }))
                      }
                      onChange={(e) => handleChange(e, "services")}
                      styles={{
                        container: (provided) => ({ ...provided }),
                      }}
                    />
                  </div>
                </div>
                {formData.serviceName !== "Consultation" && (
                  <>
                    <div className="col-xl-6">
                      <div className="form-group">
                        <label
                          htmlFor="isClient"
                          className="col-form-label me-3"
                        >
                          Is Client:
                        </label>
                        <div className="d-flex gap-5 align-items-center">
                          {["No", "Yes"].map((status) => (
                            <div
                              className="form-check d-flex gap-1"
                              key={status}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="isClient"
                                id={status.toLowerCase()}
                                value={status}
                                checked={formData.isClient === status}
                                onChange={(e) => handleChange(e, "isClient")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={status.toLowerCase()}
                              >
                                {status}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    {formData.isClient === "Yes" && (
                      <div className="col-xl-6">
                        <div className="form-group position-relative">
                          <label
                            htmlFor="application"
                            className="col-form-label"
                          >
                            Clients:
                          </label>
                          <Select
                            options={
                              allClinicLists &&
                              allClinicLists?.map((client, i) => ({
                                value: client?._id,
                                label: client?.userId?.name,
                              }))
                            }
                            onChange={(e) => handleChange(e, "client")}
                            styles={{
                              container: (provided) => ({ ...provided }),
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div className="col-xl-6">
                  <div className="form-group position-relative">
                    <label htmlFor="application" className="col-form-label">
                      Service Mode:
                    </label>
                    <Select
                      options={
                        serviceModes &&
                        serviceModes?.map((serviceMode) => ({
                          value: serviceMode.value,
                          label: serviceMode.label,
                        }))
                      }
                      onChange={handleserviceModeChange}
                      styles={{
                        container: (provided) => ({ ...provided }),
                      }}
                    />
                  </div>
                </div>
                <>{renderExtraFieldsComponent()}</>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setModalVisible(false)}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={submitLoading}
                >
                  {submitLoading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                  ) : null}
                  {submitLoading ? "Please wait..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </Modal>
        {/* <AddUser
        formData={formData}
        genderOptions={genderOptions}
        showUserModal={showUserModal}
        setShowUserModal={setShowUserModal}
        handleChange={handleChange}
        handleSetPhoneNumber={handleSetPhoneNumber}
        userInput={userInput}
        setModalVisible={setModalVisible}
      /> */}
        {/* <AddReferrer
          formData={formData}
          setFormData={setFormData}
          services={services}
          showReferrerModal={showReferrerModal}
          setShowReferrerModal={setShowReferrerModal}
          setModalVisible={setModalVisible}
          referrInput={referrInput}
          handleSelectServiceDetailsChange={handleSelectServiceDetailsChange}
          handleSetPhoneNumber={handleSetPhoneNumber}
          handleChange={handleChange}
          handleAddField={handleAddField}
          handleRemoveField={handleRemoveField}
        /> */}
      </div>
      <AddUpdateModal
        modalVisible={showPatientModal}
        setModalVisible={setShowPatientModal}
        formData={patientFormData}
        setFormData={setPatientFormData}
        inputError={inputError}
        setInputError={setInputError}
        dispatch={dispatch}
        resetForm={resetForm}
        cities={cities}
        Country={Country}
        state={state}
        districts={districts}
        handleFileChange={handleFileChange}
        handleSelectChange={handlePatientSelectChange}
        handleChange={patientHandleChange}
        handleAddPatient={handleAddPatient}
        bloodGroupOptions={BloodGroupOptions}
        membershipOptions={MembershipOptions}
        genderOptions={Genderoptions}
        fieldErrors={fieldErrors}
        setFieldErrors={setFieldErrors}
      />
      <AddUpdateReferrerList
        showModals={showModals}
        setshowModals={setshowModals}
        handleCloseModal={handleCloseModal}
        handleAddUpdate={handleAddUpdate}
        userFormData={userFormData}
        setUserFormData={setUserFormData}
        isMode={isMode}
        handleChanges={handleChanges}
        handleSelectChange={handleSelectChange}
        services={services}
        handleAddField={handleAddField}
        setInputError={setInputError}
        handleRemoveField={handleRemoveField}
        handleSetPhoneNumber={handleSetPhoneNumbers}
        userInput={userInput}
      />
    </>
  );
};

export default ApptModalCommon;
